import { formatNumberWithCustomSeparator } from './formatNumberWithCustomSeparator';

type FormatSuffixNumber = {
  prefix?: string;
  suffix?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  thousandsSeparator?: string;
  decimalSeparator?: string;
};

export function formatSuffixNumber(
  value: number,
  {
    prefix,
    suffix,
    minimumFractionDigits,
    maximumFractionDigits,
    thousandsSeparator = ',',
    decimalSeparator
  }: FormatSuffixNumber = {}
) {
  return [
    prefix,
    formatNumberWithCustomSeparator(
      toFixedNumber(value, minimumFractionDigits, maximumFractionDigits),
      thousandsSeparator,
      decimalSeparator
    ),
    suffix
  ].join('');
}

export function toFixedNumber(
  number: number,
  minimumFractionDigits?: number,
  maximumFractionDigits?: number
) {
  return number.toLocaleString(undefined, {
    minimumFractionDigits,
    maximumFractionDigits,
    useGrouping: false
  });
}
